import { atom } from 'recoil';
import { recoilPersist } from "recoil-persist"
const { persistAtom  } = recoilPersist();
export const setLoggedIn = atom({
    key: "setLoggedIn",
    default: [],
    effects_UNSTABLE: [persistAtom ]
});